export const sxStyle = {
  linksAndCopy: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: { xs: '12px', md: '16px' },
    py: { xs: 1, md: 0 },
  },

  copyrightText: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: { xs: '10px', md: '11px' },
    lineHeight: 1.6,
    textAlign: 'center',
    px: { xs: 1, md: 3 },
  },
  footerLogosContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: { xs: '20px', md: '36px', lg: '44px' },
    flexWrap: 'wrap',
    width: '100%',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    opacity: 0.8,
    transition: 'opacity 0.2s',
    '&:hover': { opacity: 1 },
  },
  footer_logo: {
    width: { xs: 64, md: 80 },
    height: { xs: 64, md: 80 },
    objectFit: 'contain',
    filter: 'brightness(0) invert(1)',
  },
};
